<template>
  <div class="column is-12" id="chartsTop">
    <p v-if="data && text.period" class="subtitle has-text-centered">
      <small
        v-html="text.period.replace('{period}', ('<b>' + moment(data.StartDate).format('D MMMM YYYY') + ' - ' + moment(data.EndDate).format('D MMMM YYYY') + '</b>'))">
      </small>
      <small v-if="text.period_info" v-tooltip class="has-tooltip-right has-tooltip-multiline tooltip-has-enters"
        :data-tooltip="text.period_info.replace(/;/g, '\u000D\u000A')">
        <font-awesome-icon :size="'xs'" :icon="icons.info" />
      </small>
    </p>
    <div class="columns indicators">
      <div class="column is-5 is-offset-1">
        <div class="box has-text-centered">
          <loader :loading="!loaded" :fixed="false"></loader>
          <div v-if="loaded">
            <p class="heading has-text-grey" v-if="text.total_indicator">
              {{
                text.total_indicator.replace(
                  "{date}",
                  moment(data.EndDate).format("D MMMM")
                )
              }}
            </p>
            <p class="title">
              <font-awesome-icon :size="'xs'" :icon="
                icons[
                data.DifferenceTotalAccidents > 0
                  ? 'up'
                  : data.DifferenceTotalAccidents === 0
                    ? 'equal'
                    : 'down'
                ]
              " />
              {{ numberFormatter(data.DifferenceTotalAccidents, 0) }}
            </p>
            <small class="postheading has-text-grey"
              v-if="text.total_indicator_post_year && moment(data.EndDate).format('YYYY') !== currentYear">{{ text.total_indicator_post_year.replace('{activeLastYear}', moment(data.EndDate).format('YYYY')) }}</small>
            <small class="postheading has-text-grey"
              v-else-if="text.total_indicator_post">{{ text.total_indicator_post }}</small>
          </div>
        </div>
      </div>
      <div class="column is-5">
        <div class="box has-text-centered">
          <loader :loading="!loaded" :fixed="false"></loader>
          <div v-if="loaded">
            <p class="heading has-text-grey" v-if="text.casualtie_indicator">
              {{
                text.casualtie_indicator.replace(
                  "{date}",
                  moment(data.EndDate).format("D MMMM")
                )
              }}
            </p>
            <p class="title">
              <font-awesome-icon :size="'xs'" :icon="
                icons[
                data.DifferenceVictimAccidents > 0
                  ? 'up'
                  : data.DifferenceVictimAccidents === 0
                    ? 'equal'
                    : 'down'
                ]
              " />
              {{ numberFormatter(data.DifferenceVictimAccidents, 0) }}
            </p>
            <small class="postheading has-text-grey"
              v-if="text.casualtie_indicator_post_year && moment(data.EndDate).format('YYYY') !== currentYear">{{ text.casualtie_indicator_post_year.replace('{activeLastYear}', moment(data.EndDate).format('YYYY')) }}</small>
            <small class="postheading has-text-grey"
              v-else-if="text.casualtie_indicator_post">{{ text.casualtie_indicator_post }}</small>
          </div>
        </div>
      </div>
    </div>
    <h2 class="subtitle has-text-centered" v-if="text.graphs_title"><span>{{ text.graphs_title.replace('{startYear}', moment(data.StartDate).format('YYYY')).replace('{endYear}', moment(data.EndDate).format('YYYY')) }}</span></h2>
    <div class="columns is-variable is-2">
      <loader :loading="!loaded" :fixed="false"></loader>
      <div class="field column is-4" v-for="index in 3" :key="index">
        <chart class="chart" v-if="loaded" :options="chartsData[index - 1]" :constructor-type="'chart'" :updateArgs="[
          true,
          true,
          {
            duration: 1000,
          },
        ]"></chart>
      </div>
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import { Chart } from 'highcharts-vue'
import loader from '@/components/Loader.vue'
import moment from 'moment'
import {
  faChevronDoubleUp,
  faChevronDoubleDown,
  faMinus
} from '@fortawesome/pro-duotone-svg-icons'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'contentChartsTop',
  props: {
    text: {
      type: Object,
      required: false,
      default: () => { }
    },
    countryCode: {
      type: String,
      default: 'NLD'
    }
  },
  data () {
    return {
      loaded: false,
      moment: moment,
      chartsData: [null, null, null],
      colors: [
        ['rgb(110,195,198)', 'rgb(226,97,99)', 'rgb(63,17,21)'],
        ['green', 'red', 'black']
      ],
      icons: {
        up: faChevronDoubleUp,
        down: faChevronDoubleDown,
        equal: faMinus,
        info: faInfoCircle
      },
      country: this.countryCode || this.$store.state.country,
      numberFormatter: Highcharts.numberFormat,
      currentYear: new Date().getFullYear().toString()
    }
  },
  components: { Chart, loader },
  computed: {
    activeColorIndex () {
      return this.$store.state.dark ? 1 : 0
    },
    data () {
      return this.$store.state.publicAccidentData
    }
  },
  methods: {
    setChartData: function (colorIndexChanged) {
      this.loaded = false
      colorIndexChanged = colorIndexChanged || false
      for (var i = 0; i < this.chartsData.length; i++) {
        var title = this.text.hasOwnProperty(
          this.data.YearChart.Data[i].Title.toLowerCase()
        )
          ? this.text[this.data.YearChart.Data[i].Title.toLowerCase()]
          : this.data.YearChart.Data[i].Title
        this.chartsData[i] = {
          chart: {
            reflow: true,
            type: 'column',
            backgroundColor: 'transparent'
          },
          title: {
            align: 'center',
            text: title,
            style: {
              fontSize: '14px'
            }
          },
          credits: {
            enabled: false
          },
          xAxis: {
            categories: this.data.YearChart.Labels.split(',').map(function (j) {
              return j.replace(/"/g, '')
            }),
            labels: {
              style: {
                fontSize: '9px'
              },
              rotation: 0
            }
          },
          yAxis: {
            allowDecimals: false,
            min: 0,
            title: {
              text: null
            },
            labels: {
              style: {
                fontSize: '9px'
              }
            }
          },
          legend: { enabled: false },
          plotOptions: {
            series: {
              cursor: 'pointer',
              marker: {
                states: {
                  select: {
                    lineColor: false,
                    lineWidth: false,
                    fillColor: false
                  }
                }
              }
            }
          },
          series: [
            {
              name: title,
              type: 'column',
              color: this.colors[this.activeColorIndex][i],
              data: this.data.YearChart.Data[i].Data
            }
          ]
        }
      }
      this.loaded = true
    }
  },
  mounted () {
    var _this = this

    _this.country = _this.countryCode || _this.$store.state.country

    moment.locale(this.$store.state.language)
    if (this.$store.state.publicAccidentData) {
      this.setChartData()
    } else {
      this.$store.dispatch('getPublicAccidentData', _this.country)
    }
  },
  watch: {
    '$store.state.publicAccidentData': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.setChartData()
        }
      },
      immediate: false
    },
    '$store.state.language': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.setChartData()
        }
      },
      immediate: false
    },
    '$store.state.dark': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.setChartData()
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
#chartsTop {
  padding-top: 0px;

  .indicators {
    .title {
      margin: 0;
    }

    [data-icon] {
      color: $grey;
    }

    [data-icon="chevron-double-up"] {
      color: $danger;
    }

    [data-icon="chevron-double-down"] {
      color: $success;
    }

    @media screen and (min-width: 1000px) {
      max-width: 1000px;
      margin: 0px auto 10px;
    }
  }

  >p.subtitle {
    font-weight: 300;
    margin-bottom: 0.5em;
  }

  .columns {
    position: relative;

    .box {
      position: relative;
      min-height: calc(52px + 1.5rem);
      height: 100%;
      padding: 0.75rem 1.25rem;

      >div {
        display: flex;
        flex-direction: column;
        height: 100%;

        .heading {
          flex: 1;
        }

        .postheading {
          letter-spacing: 1px;
          text-transform: uppercase;
          line-height: 1.5;
          font-size: 9px;
          opacity: 0.4;
        }
      }
    }

    .is-4 {
      height: 220px;
    }

    .chart {
      height: 220px;
    }
  }

  @media screen and (max-width: $bp-tablet - 1px) {
    .columns {
      .chart {
        height: 200px;
      }
    }
  }
}
</style>
